let printer_BillPrintActions = require("../../templates/printer/BillPrintActions.handlebars");
let table_listItem = require("../../templates/table/listItem.handlebars");
let table_BillsTabContainer = require("../../templates/table/BillsTabContainer.handlebars");
let table_WebBillList = require("../../templates/table/WebBillList.handlebars");
let table_BillList = require("../../templates/table/BillList.handlebars");
let table_BillItem = require("../../templates/table/BillItem.handlebars");
let BillDetails = require("../../templates/table/BillDetails.handlebars");
let PasswordEntry = require("../../templates/pos/comp/PasswordEntry.handlebars");
let PasswordEntryView = require("../comp/PasswordEntryView.js");

let $ = require('jquery');
let _ = require("underscore");
let moment = require('moment');
let Backbone = require("backbone");
import PrintService from "../../service/PrintService.js";

let TableModel = require("../../model/TableModel.js");
import BillItemModalView from "./BillItemModalView.js";
import SwitchTableModalView from "./SwitchTableModalView.js";
import BillItemsSelectModalView from "../comp/BillItemsSelectModalView.js";
import i18n from "../../utils/i18n";
import BillPrintActionsView from "../printer/BillPrintActionsView.js";
import POS from "../../POS.js";

let PagingView = require("../comp/PagingView.js");
let PagingModel = require("../../model/PagingModel.js");

let DbRecorder = require("../../recorder/DbRecorder.js");
import ModalView from "../comp/ModalView.js";

let BasePagingModel = require("../../model/BasePagingModel.js");
import BillRefundModalView from "./BillRefundModalView.js";

let ChooseMemberModalView = require("../ChooseMemberModalView.js");


let main = function () {
    return Backbone.View.extend({
        BillListPageSize: 10,
        orderListPagingModel: new BasePagingModel(),
        chooseMemberModalView: null,
        lastRefresh: 0,
        lastActiveBillIndex: 0,
        billsTabContainerHeight: 0,
        BillPrintActionsView: null,
        events: {
            'click .pageUp': 'pageUp',
            'click .pageDown': 'pageDown',
            'click .orderitem:not(.shallow)': 'itemEditor',
            'click .sidebar .close-table:not(.disabled)': 'closeTable',
            'click .sidebar .switch-table:not(.disabled)': 'switchTable',
            'click .sidebar .billList': 'billList',
            'click .sidebar .toOrder:not(.disabled)': 'toOrder',
            'click .webbill,.bill': 'showBillPopup',
            'click .billsTabContainer .btn-print': '_printBillInTab',
            'click .billsTabContainer .btn.confirm': 'confirmOrder',
            'click .billsTabContainer .btn.cancel': 'cancelOrder',
            'click .billsTabContainer .btn.refund': '_refundBill',
            'click .billsTabContainer .btn.on-switch': '_switchBillItems',
            'click .billsTabContainer .btn.on-credit,.billsTabContainer .btn.cancel-credit': '_creditBill',
            'click .billListView .refund': '_refundBill',
            'click .billListView .print': 'printBill',
            'click .bill-details .print-bill': 'printBill',
            'click .checkout': "beforeCheckOut",
            'click .diner-level .quantity-editor .plus-btn': "plusNum",
            'click .diner-level .quantity-editor .minus-btn': "minusNum",
            'click .orderitem:not(.shallow) .status': 'completeItem',
            'click .bill-list li, .billsTabContainer li': '_changeTab',
            'click .deliver': "deliver_click",
            'click .courier,.show-courier': "_setCourier",
            "click .delete-staff": "_deleteStaff",
            'click .bill-list .add-item': '_addItem',
            "click .billAmountInfo": "showLeftPanel",
            'click .billist-open': "toggleBillList",
            'click .btn.add-item': '_addItem',
            'click .billModal .orderitem': 'onBillItemClick',
            'click .billModal .confirm': '_refundItems',
            'click .billModal .print-bill': 'printSearchBill',
            'click .billModal .refund-bill': 'showRefundPage',
            'click .billModal .cancel': 'hideRefundPage',
            'click .billModal .selected-all': 'selectAll'
        },

        printEL: null,
        initialize: function () {
            var self = this;
            if (!this.model) {
                this.model = new TableModel();
            }

            if (!this.pagingViews) {
                this.pagingViews = [];
            }
            if (!self.printEL) {
                self.printEL = $(printer_BillPrintActions());
            }
            this.throttled_refresh = _.debounce(_(this._refresh).bind(this), 200);
            $(window).on("resize", () => {
                this.billsTabContainerHeight = null;
                this.throttled_refresh();
            });
        },
        fastKeyCode: function (evt) {
            // 初始化BillPrintActionsView
            var self = this, bill, printActionsView,
                cid = $(".billsTabContainer .tab-pane.active .printerOrder").data("cid");
            bill = self.model.getActiveBillCollection().get(cid);
            printActionsView = new BillPrintActionsView({
                bill: bill,
                table: self.model,
                model: new Backbone.Model({}),
                el: self.printEL
            });
            printActionsView.fastKeyCode(evt);

            //本视图中调用含有当前点击对象参数的方法，没有参数的方法均放在postView中调用；
            if (evt.keyCode == "80") {
                if ($(".modal-content.printActionModal").css("display") == 'none' || $(".modal-content.printActionModal").css("display") == undefined) {
                    bill = self.model.getActiveBillCollection().get(cid);
                    printActionsView = new BillPrintActionsView({
                        bill: bill,
                        table: self.model,
                        model: new Backbone.Model({}),
                        el: self.printEL
                    });
                    var printActionsViewModal = new ModalView({
                        body: printActionsView.el,
                        title: i18n.msg("pos.printer.receipt.type.selection.label"),
                        save: i18n.msg("pos.label.print")
                    }).render();
                    printActionsViewModal.$el.find(".modal-content").addClass("printActionModal");
                    printActionsViewModal.$el.find(".btn-confirm").addClass("printAction");
                    printActionsViewModal.model.on("change:confirmedTime", function () {
                        printActionsView._print();
                        printActionsViewModal.close();
                    });
                    printActionsViewModal.model.on("change:closeTime", function () {
                        printActionsViewModal.close();
                    });
                }
            }

            if (evt.keyCode == "27") {
                if ($(".modal-content.printActionModal").css("display") == 'block') {
                    $(".modal-content.printActionModal").parent().parent().remove();
                    $(".modal-backdrop").remove();
                }
            }
            if (evt.keyCode == "66") {//账户B
                var self = this;
                var table = self.model;
                var billId = $(".btn.checkout").data("id");
                if (!billId) {
                    billId = $(".btn.checkout").closest('a').data("id");
                }
                var bills = this.model.getBillCollection();
                var selectedBill = bills.get(billId);
                if (selectedBill) {
                    self.model.setCurrentBill(selectedBill)
                }
                const TOOIE = window.TOOIE_INIT_PARAMS;
                if (TOOIE.isExpRest) {
                    _mp("V开始结账");
                }
                window.location.href = $(".btn.checkout").attr("href") || $(".btn.checkout").closest("a").attr("href");
                return false;
            }
        },

        selectAll: function (evt) {
            var selectAll = $(evt.currentTarget);
            _.each($(".item-body .orderitem:not(.hasRefund)"), function (item) {
                if (selectAll.hasClass("selected")) {
                    $(item).removeClass("selected").find("img").prop("src", require("../../images/pos/settings/itemUnchecked.png"));
                    selectAll.prop("src", require("../../images/pos/settings/itemUnchecked.png"));
                } else {
                    $(item).addClass("selected").find("img").prop("src", require("../../images/pos/settings/itemChecked.png"));
                    selectAll.prop("src", require("../../images/pos/settings/itemChecked.png"));
                }
            });
            selectAll.toggleClass('selected');
        },
        hideRefundPage: function () {
            var modal = this.$('.billModal'), modalBody = modal.find('.modal-body');
            modalBody.find('.refunds').hide();
            modalBody.find('.item-foot').hide();
            modalBody.find('.title').show();
            modalBody.find('.item-selected img').addClass('hidden');
            modalBody.siblings('.modal-header').show();
        },
        showRefundPage: function () {
            var modal = this.$('.billModal'), modalBody = modal.find('.modal-body');
            modalBody.find('.refunds').show();
            modalBody.find('.item-foot').show();
            modalBody.find('.title').hide();
            modalBody.find('.item-selected img').removeClass('hidden');
            modalBody.siblings('.modal-header').hide();
        },
        onBillItemClick: function (evt) {
            if ($(evt.currentTarget).hasClass('hasRefund')) {
                return;
            }
            if ($(evt.currentTarget).find(".item-selected img").hasClass('hidden')) {
                return;
            }
            if ($(evt.currentTarget).hasClass("selected")) {
                $(evt.currentTarget).find(".item-selected img").prop("src", require("../../images/pos/settings/itemUnchecked.png"));
            } else {
                $(evt.currentTarget).find(".item-selected img").prop("src", require("../../images/pos/settings/itemChecked.png"));
            }
            $(evt.currentTarget).toggleClass('selected');
        },
        //增加用餐人数
        plusNum: function () {
            var self = this, quantityInput = self.$(".quantity-input");
            var table = self.model;
            var bill = table.getCurrentBill();
            var dinerCount = bill.get("dinerCount");
            if (dinerCount >= 99) {                                 //限制一个bill的最多用餐人数为99
                return;
            }
            quantityInput.val(dinerCount + 1);
            bill.set({dinerCount: dinerCount + 1}, {silent: true});
        },
        //减少用餐人数
        minusNum: function () {
            var self = this, quantityInput = self.$(".quantity-input");
            var table = self.model;
            var bill = table.getCurrentBill();
            var dinerCount = bill.get("dinerCount");
            if (dinerCount <= 0) {                               //限制一个bill的最少用餐人数为0（0对应增加餐品的情况）
                return;
            }
            quantityInput.val(dinerCount - 1);
            bill.set("dinerCount", dinerCount - 1, {silent: true});
        },
        selectPanel: function (evt) {
            console.log(evt);
        },
        _changeTab: function (evt) {
            var self = this, li = $(evt.currentTarget), a = li.find('a');

            this.lastActiveBillIndex = li.index();
            var panelA = $(".billsTabContainer a[href='" + a.attr('href') + "']");
            var panelB = $(".billsTabContainer .tab-pane[id=billtab-" + a.attr('href').split('-')[1] + "]");
            if (panelA) {
                panelA.closest('li').addClass('active').siblings('li').removeClass('active');
                panelB.addClass('active').siblings('.tab-pane').removeClass('active');
            }
            var bill = self.model.getActiveBillCollection().get({cid: a.data('cid')});
            if (bill) {
                if (!self.model.billCanSwitch(bill)) {
                    self.$(".sidebar .switch-table").attr("disabled", "disabled");
                    self.$(".sidebar .switch-table").addClass("disabled");
                } else {
                    self.$(".sidebar .switch-table").removeAttr("disabled");
                    self.$(".sidebar .switch-table").removeClass("disabled");
                }
            }
            self.$(".sidebar .active").removeClass('active');
            self.$('.bill-list .add-item').addClass('hidden');
            li.addClass('active').siblings('li').removeClass('active');
            li.find('.add-item').removeClass('hidden');
            self.showCurrentBill();
            self._updateDinerCount();
            self.toggleBillList();
        },
        _updateDinerCount: function () {
            var self = this;
            if (self.$('.bill-list li.active a').size() == 0) {
                return;
            }
            var cid = self.$('.bill-list li.active a').attr('href').split('-')[1];
            var dinerCountBill;
            self.model.getActiveBillCollection().each(function (bill) {
                if (cid == bill.cid) {
                    dinerCountBill = bill;
                }
            });
            if (dinerCountBill.isPaid()) {
                self.$(".sidebar .quantity-editor .btn").addClass("hidden");
                self.$('.table-left.sidebar').removeClass('unpaid');
                self.$('.table-left.sidebar').addClass('paid');
            } else {
                self.$(".sidebar .quantity-editor .btn").removeClass("hidden");
                self.$('.table-left.sidebar').removeClass('paid');
                self.$('.table-left.sidebar').addClass('unpaid');
            }
            self.$(".quantity-input").val(dinerCountBill.get('dinerCount'));
        },
        completeItem: function (evt) {
            var self = this, orderitem = $(evt.currentTarget).closest('.orderitem');
            var cid = orderitem.data('cid'), item = null;
            var bill = this.model.getActiveBillCollection().find(function (billModel) {
                item = billModel.getBillItems().get(cid);
                return item ? true : false;
            });
            if (!item) {
                return false;
            }
            var status = orderitem.hasClass('Completed') ? 'Confirmed' : 'Completed';
            item.set({status: status});
            self._postStatusChange(status, item);
            self.refresh(self.model);
            return false;
        },
        _postStatusChange: function (status, item) {
            var self = this, data, jxhr;
            data = {restaurantId: POS.getRestaurant().id, id: item.id, status: status};
            jxhr = $.post("/bill/updateBillItemStatus", data);
            jxhr.fail(function (resopnse) {
                console.log("Failed to update bill item status " + item.id);
            });
        },
        _printBillInTab: function (evt) {
            var self = this, bill, printActionsView,
                cid = $(evt.currentTarget).data("cid");
            bill = self.model.getActiveBillCollection().get(cid);
            printActionsView = new BillPrintActionsView({
                bill: bill,
                table: self.model,
                model: new Backbone.Model({}),
                el: self.printEL
            });
            var printActionsViewModal = new ModalView({
                body: printActionsView.el,
                title: i18n.msg("pos.printer.receipt.type.selection.label"),
                save: i18n.msg("pos.label.print")
            }).render();
            printActionsViewModal.$el.find(".modal-content").addClass("printActionModal");
            printActionsViewModal.$el.find(".btn-confirm").addClass("printAction");
            printActionsViewModal.model.on("change:confirmedTime", function () {
                printActionsView._print();
                printActionsViewModal.close();
            });
            printActionsViewModal.model.on("change:closeTime", function () {
                printActionsViewModal.close();
            });
        },

        refresh: function (model) {
            var self = this;
            if (model.id != self.model.id) {
                return;
            }
            this.throttled_refresh();
        },

        _refresh: function () {
            var self = this;
            var model = self.model;
            var symbol = POS.getRestaurant().get("currencySymbol");
            var printable = POS.getPrinterSetting().isPrintable();
            var bills = [];
            var billCount = model.getActiveBillCollection().length;
            if (this.lastActiveBillIndex > billCount - 1) {
                this.lastActiveBillIndex = billCount - 1;
            }
            this.lastActiveBillIndex = Math.max(0, this.lastActiveBillIndex);
            model.getActiveBillCollection().each(function (bill, index) {
                bill.calculateAmount();
                var billJSON = bill.toJSON(), incompleteItems;
                billJSON.cid = bill.cid;
                billJSON.items = [];
                bill.getBillItems().each(function (item) {
                    var json = item.toJSON();
                    json.cid = item.cid;
                    json._status = "pos.bill.item.status." + json.status.toLowerCase();
                    json.price = symbol + json.price;
                    if (item.get("discount")) {
                        var discount = DbRecorder.convert2JSON(item.get("discount"));
                        if (!discount.deleted) {
                            json.discount = discount.name;
                        }
                    }
                    var tagNames = _.map((item.get("tags") || []).models, function (tag) {
                        return tag.get("name");
                    });
                    if (json.discount && tagNames.length > 2) {
                        tagNames = tagNames.slice(0, 2);
                    } else if (!json.discount && tagNames.length > 3) {
                        tagNames = tagNames.slice(0, 3);
                    }
                    json.tagNames = tagNames;
                    json.tagNameList = (tagNames || []).join(",");
                    if (item.get("orderedQuantity") == 0) {
                        json.totalRefund = true;
                    }
                    billJSON.items.push(json);
                });
                billJSON.confirmed = bill.isConfirmed();
                billJSON.canceled = bill.isCanceled();
                billJSON.refunded = bill.getRefundStatus() == "Total";

                billJSON.paid = bill.isPaid();
                billJSON.pingId = bill.get("pingId");
                billJSON.thirdParty = bill.isThirdParty();
                billJSON.hasPaidOnline = bill.get("hasPaidOnline");
                incompleteItems = bill.getBillItems().filter(function (it) {
                    return it.get('status') != "Completed";
                });
                if (index == self.lastActiveBillIndex) {
                    billJSON.active = true;
                }
                billJSON.billStatus = {
                    code: "pos.bill.status." + billJSON.status,
                    tableId: self.model.get("id"),
                    lastUpdated: bill.get("lastUpdated"),
                    incompleteItemCount: incompleteItems.length,
                    orderedItemCount: bill.getBillItems().length,
                    currencySymbol: POS.getRestaurant().get("currencySymbol"),
                    originalShouldPayAmount: bill.getOriginalShouldPayAmount(),
                    unpaid: !bill.isPaid(),
                    refunded: bill.getRefundStatus() == "Total",
                    dinerCount: bill.get("dinerCount"),
                    note: bill.get('note')
                };
                billJSON.time = new moment(bill.get("orderDate") ? bill.get("orderDate") : bill.get('checkInDate')).format('HH:mm');
                billJSON.index = index + 1;
                billJSON.reverseIndex = billCount - index;
                billJSON.webTable = model.isWebTable();
                billJSON.version = bill.get('version');

                bills.push(billJSON);
                if (DbRecorder.read("lastNotifiedTakeawayBill") < bill.id) {
                    DbRecorder.saveNow("lastNotifiedTakeawayBill", bill.id);
                }
            });

            self.$(".bill-list ul").empty().append(table_listItem({
                bills: bills
            }));
            _.each(bills, function (bill) {
                _.each(bill.items, function (item) {
                    item.menuItemName = item.menuItem.status == "Unavailable" ? item.menuItem.name.split('-')[1] + i18n.msg('pos.menu.item.delete') : item.menuItem.name;
                });
            });
            self.$(".billCount").text(bills.length);
            self.$(".table-content").empty().append(table_BillsTabContainer({
                table: model.toJSON(),
                bills: bills,
                restaurant: POS.get("restaurantModel").toJSON(),
                webTable: model.isWebTable(),
                isAdmin: POS.getUser().isAdmin
            }));
            self._updateDinerCount();
            _.each(this.pagingViews, function (view) {
                view.stopListening();
                view.undelegateEvents();
                view = null;
            });
            this.pagingViews = [];

            self.showCurrentBill();
            self.$(".billsTabContainer .tab-content > .tab-pane").each(function (index, ele) {
                var viewHeight = $(".billsTabContainer").height() - 128;
                self.pagingViews.push(new PagingView({
                    model: new PagingModel({
                        viewHeight: viewHeight,
                        rowSize: Math.max(1, $(ele).find(".orderItemList").width() / 308),
                        rowHeight: 60,
                        itemSize: $(ele).find('.pitem').size()
                    }), el: $(ele).find('.orderItemList'),
                    pagingControl: $(ele).find(".paging")
                }).render());
            });

            if (printable) {
                self.$(".btn-print").show();
            } else {
                self.$(".btn-print").hide();
            }

            if (!model.canClose()) {
                self.$(".sidebar .close-table").attr("disabled", "disabled");
                self.$(".sidebar .close-table").addClass("disabled");
            } else {
                self.$(".sidebar .close-table").removeAttr("disabled");
                self.$(".sidebar .close-table").removeClass("disabled");
            }

            var bill = self.model.getActiveBillCollection().get({cid: $('.bill-list .active a').data('cid')});
            if (!model.billCanSwitch(bill)) {
                self.$(".sidebar .switch-table").attr("disabled", "disabled");
                self.$(".sidebar .switch-table").addClass("disabled");
            } else {
                self.$(".sidebar .switch-table").removeAttr("disabled");
                self.$(".sidebar .switch-table").removeClass("disabled");
            }

            if (DbRecorder.convert2JSON(model).currentBill.items.length > 0) {
                self.$(".sidebar .print").removeAttr("disabled");
            } else {
                self.$(".sidebar .print").attr("disabled", "disabled");
            }
            if (model.isWebTable()) { // if table is for web order, it should not be able to order at pos
                self.$(".sidebar .toOrder").attr("disabled", "disabled").addClass("disabled");
                self.$(".sidebar .diner-level").attr("disabled", "disabled").addClass("disabled");
                self.$(".sidebar").addClass("webtable");
                self.$(".billListView").addClass('webtable');
            } else {
                self.$(".sidebar .toOrder").removeAttr("disabled").removeClass("disabled");
                self.$(".sidebar .diner-level").removeAttr("disabled").removeClass("disabled");
                self.$(".sidebar").removeClass("webtable");
                self.$(".billListView").removeClass('webtable');
            }
            self.showCurrentBill();
            this.lastRefresh = new Date().getTime();
            if (self.$('.table-left.sidebar .bill-list ul li').size() == 0) {
                self.$('.action-level .billList').click();
                self.$(".bill-level").hide();
            } else {
                self.$(".bill-level").show();
                self.$('.action-level .billList').removeClass("active");
            }
        },
        render: function () {
            var self = this, table = self.model;
            POS.setCurrentTable(self.model);
            table.refreshStatus();
            self.refresh(self.model);
            self.stopListening();
            self.listenTo(table, "change", function (model) {
                self.refresh(table);
            });

            self.$el.data('id', this.model.id);
            self.$('.tableName').text(this.model.get("name"));
            self.$('.orderTime').text(new moment(this.model.get('currentBill').get('dateCreated')).format("HH:mm"));
            var bill = table.getCurrentBill();
            self.listenTo(bill, "change", function () {
                //console.log('bill changed refresh table ');
                self.refresh(table);
            });

            if (bill != null) {
                self.listenTo(bill.getBillItems(), "change", function () {
                    //console.log('bill item changed refresh table ');
                    self.refresh(table);
                });
            }

            return self;
        },

        pageUp: function (evt) {
            if ($(evt.currentTarget).closest('.billListView').size() == 1) {
                this.showBillPageList("prev");
            }
        },

        pageDown: function (evt) {
            if ($(evt.currentTarget).closest('.billListView').size() == 1) {
                this.showBillPageList("next");
            }
        },

        itemEditor: function (evt) {
            var self = this;
            var cid = $(evt.currentTarget).data("cid");
            var item = null;

            var bill = this.model.getActiveBillCollection().find(function (billModel) {
                item = billModel.getBillItems().get(cid);
                return item ? true : false;
            });
            if (!item) {
                return;
            }
            if (item.get("packageId") && item.get("packageOptionName")) {
                return;
            }
            item.orderTime = new Date(item.dateCreated);
            this.listenToOnce(item, "change", function () {
                self.refresh(self.model);
            });
            if (this.modalView == null) {
                this.modalView = new BillItemModalView({
                    el: $("#menuitem-modal"),
                    table: self.model,
                    model: item,
                    bill: bill,
                    currencySymbol: POS.getRestaurant().get("currencySymbol")
                });
            } else {
                this.modalView.setElement($("#menuitem-modal"));
                this.modalView.model = item;
                this.modalView.bill = bill;
                this.modalView.table = self.model;
            }
            this.modalView.render();
        },

        closeTable: function () {
            this.$('.sidebar .active').removeClass('active');

            if (this.model.get("status") == "Closed" || !this.model.canClose()) {
                return false;
            }
            var referred = this.model.close();
            referred.done(function () {
                Backbone.history.navigate('overview', {trigger: true});
            });
            referred.fail(function () {
            });
            return true;
        },

        switchTable: function (evt) {

            //if (!this.model.canSwitch()) {
            //    return false;
            //}
            if (!this.switchTableModalView) {
                this.switchTableModalView = new SwitchTableModalView();
            }
            this.switchTableModalView.model = this.model;
            this.switchTableModalView.render();
            var _active = this.$(".sidebar .active");
            _active.removeClass("active");
            var _target = $(evt.currentTarget);
            _target.addClass("active");
            this.listenToOnce(this.switchTableModalView, "closed", function () {
                _target.removeClass("active");
                _active.addClass("active");
            });
        },

        toOrder: function () {
            var self = this;
            var unPaidBill = self.model.getActiveBillCollection().find(function (bill) {
                return bill.get('status') != 'Paid'
            });
            if (unPaidBill) {
                if (confirm(i18n.msg('pos.bill.confirm.unpaid'))) {
                    self.model.createNewBill();
                } else {
                    return
                }
            }
            this.$('.sidebar .active').removeClass('active');
            Backbone.history.navigate("order/" + this.model.get("id"), {trigger: true});
        },
        _addItem: function (evt) {
            var self = this, billId = $(evt.currentTarget).siblings('a').data('cid');

            if (!billId) {
                billId = $(evt.target).siblings('[data-cid]').data('cid')
            }
            var bill = self.model.getActiveBillCollection().get({cid: billId});

            if (bill) {
                self.model.setCurrentBill(bill);
            } else {
                return;
            }

            Backbone.history.navigate("order/" + this.model.get("id"), {trigger: true});
        },

        billList: function () {
            this.$('.sidebar .active').removeClass('active');
            this.$('.sidebar .billList').addClass('active');
            this.$('.table-content').addClass('hidden');
            var bills = this.model.getActiveBillCollection().models.reverse(),
                printable = POS.getPrinterSetting().isPrintable(),
                params = {bills: [], showTodayTotal: false},
                self = this,
                currency = POS.getRestaurant().get("currencySymbol");
            self.$('.billListView').addClass('hidden');
            _.each(bills, function (item, i) {
                console.log('show bill', item);
                var items = item.getBillItems().models;
                var itemCount = 0;                                      //餐品总数
                _.each(items, function (billitem, i) {
                    itemCount = itemCount + billitem.getOrderedQuantity();
                });
                var status = item.get('status'),
                    originalAmount = item.getOriginalAmount(),
                    amount = item.getOriginalShouldPayAmount(),
                    refundable = (item.getRefundStatus() != "Total" && !item.get("hasComment")),
                    hasRefund = (item.getRefundStatus() != "Total"),
                    refundAmount = parseFloat((item.get("refundAmount")).toFixed(2)),
                    data = {
                        originalShouldPayAmount: amount,
                        orderAmount: originalAmount,
                        id: item.id,
                        cid: item.cid,
                        time: new moment(item.get('orderDate') ? item.get('orderDate') : item.get('checkInDate')).format('HH:mm'),
                        originalAmount: originalAmount,
                        amount: amount,
                        itemCount: itemCount,
                        status: i18n.msg('bill.status.' + status),
                        refundable: refundable,
                        printable: printable,
                        showRefund: true,
                        noAntisettlement: true,
                        currency: currency,
                        refundAmount: refundAmount,
                        sid: item.get('sid') ? item.get('sid') : item.id,
                        hasRefund: hasRefund,
                        locked: item.get('locked')
                    };
                if (!data.id) {
                    data.id = data.cid;
                }
                if (!data.sid) {
                    data.sid = data.cid;
                }

                if (self.model.isWebTable()) {
                    var record = item.get('shippingRecord');
                    if (record) {
                        data.name = record.consignee;
                        data.address = record.address;
                        data.phone = record.phone
                    }
                    if (item.getRefundStatus() == "Total") {
                        data.status = i18n.msg('bill.status.Refunded');
                    }
                }

                params.bills.push(data);
            });

            if (bills.length < 1) {
                params.showEmptyLabel = true
            } else {
                params.showEmptyLabel = false
            }


            params.table = self.model.toJSON();
            params.webTable = self.model.isWebTable();
            params.restaurant = POS.get("restaurantModel").toJSON();

            this.$('.billListView').removeClass('hidden').empty().append(
                self.model.isWebTable() ? $(table_WebBillList(params)) : $(table_BillList(params))
            );
        },

        showCurrentBill: function () {
            this.$('.sidebar .currentBill').addClass('active');
            this.$('.table-content').removeClass('hidden');
            this.$('.billListView').addClass('hidden');
        },

        showBillPopup: function (evt) {
            var bill, billItem = $(evt.currentTarget),
                shallow = false, cid,
                modal = this.$('.webOrderModal'),
                modalBody = modal.find('.modal-body'),
                symbol = POS.getRestaurant().get("currencySymbol");
            shallow = billItem.hasClass("shallow");
            if (billItem.data('id')) {
                bill = this.model.getActiveBillCollection().find({id: billItem.data('id')});

            } else {
                bill = this.model.getActiveBillCollection().find(function (item) {
                    return item.cid == billItem.data('cid');
                });
            }
            modal.addClass('billModal');
            cid = bill.cid;
            modal.data('id', bill.id).data('cid', cid).modal();
            modalBody.find('.row').empty();
            var json = {}, items = [], itemCount = 0;
            bill.getBillItems().each(function (item) {
                var jsonItem = item.toJSON();
                jsonItem.cid = item.cid;
                jsonItem._status = "pos.bill.item.status." + jsonItem.status.toLowerCase();
                jsonItem.itemPrice = symbol + jsonItem.price;
                jsonItem.shallow = shallow;
                itemCount += jsonItem.orderedQuantity;
                items.push(jsonItem);
            });
            json = DbRecorder.convert2JSON(bill);
            json.cid = cid;
            json.items = items;
            json.itemCount = itemCount;
            json.refundable = false;
            json.refundstatus = (json.refundStatus == "Total");
            var method = "";
            $.each(DbRecorder.convert2JSON(bill).payments, function (index, value) {
                if (value.type == "Payment") {
                    if (value.method == "IGNORE" || value.method == "TIP") {
                        return;
                    }
                    switch (value.method) {
                        case "MEMBER_CARD":
                            method += i18n.msg("pos.payment.method.MEMBER_CARD");
                            break;
                        case "WEIXIN_POS":
                            method += i18n.msg("pos.payment.method.WECHAT");
                            break;
                        case "ALIPAY_POS":
                            method += i18n.msg("pos.payment.method.ALIPAY");
                            break;
                        case "CASH":
                            method += i18n.msg("pos.payment.method.CASH");
                            break;
                        case "CUSTOM":
                            method += i18n.msg("pos.payment.method.OTHER_PAY");
                            break;
                        case "CREDIT_CARD":
                            method += i18n.msg("pos.payment.method.CREDIT_CARD");
                            break;
                        case "ALIPAY":
                            method += i18n.msg("pos.payment.method.ALIPAY");
                            break;
                        case "WEIXIN":
                            method += i18n.msg("pos.payment.method.WECHAT");
                            break;
                        case "COUPON":
                            method += i18n.msg("pos.payment.method.COUPON");
                            break;
                        case "OTHER_PAY":
                            method += i18n.msg("pos.payment.method.OTHER_PAY");
                            break;
                        default:
                            method += i18n.msg("pos.payment.method.CASH");
                            break;
                    }
                    if (value.customPayment) {
                        method = value.customPayment.name;
                    }
                    method += "  "
                }
            });
            json.paymentMethod = method;
            json.locked = bill.get('locked');
            modalBody.find('.row').append(BillDetails(json));
            modalBody.find('.refunds').hide();
            modalBody.find('.item-foot').hide();
        },

        confirmOrder: function (evt) {
            var self = this,
                table = self.model,
                confirmModel = new Backbone.Model({}),
                message = i18n.msg('pos.bill.confirm.confirmation'),
                btn = $(evt.currentTarget),
                data = btn.data(),
                bill = data.id ? table.getActiveBillCollection().get(data.id) : table.getActiveBillCollection().get(data.cid);

            if (bill) {
                confirmModel.on("change:shouldConfirm", function () {
                    bill.pleaseConfirm();
                    confirmModel.set({confirmed: true});
                    self.model.setCurrentBill(bill);

                    if (!bill.get("hasPaidOnline")) {
                        btn.closest(".status-item").find(".checkout").removeClass('hidden');
                    } else {
                        var payments = bill.get("payments");
                        bill.calculateAmount();
                        payments.add({method: "STRIPE", amount: bill.getOriginalShouldPayAmount()});
                        _.each(bill.getConfirmedItems(), function (item) {
                            if (item.getOrderedQuantity() > 0) {
                                item.set({paid: true});
                            }
                        });
                        bill.set({status: "Paid", payStatus: "Paid"});
                        bill.setPayDate();
                    }
                    btn.remove();
                    table.trigger("change");
                    self._printBill(bill);
                    if (DbRecorder.read("lastNotifiedTakeawayBill") < bill.id) {
                        DbRecorder.saveNow("lastNotifiedTakeawayBill", bill.id);
                    }
                });
                new ModalView({
                    model: confirmModel,
                    body: "<h3 style='text-align: center;'>" + message + "</h3>",
                    save: i18n.msg('pos.order.confirm.yes')
                }).render();
            }
        },
        _printBill: function (bill) {
            var printSetting = POS.getPrinterSetting();
            var unConfirmItems = DbRecorder.convert2JSON(bill.getUnconfirmedItems());
            var unConfirmTotal = bill.getUnconfirmedTotal();
            var billLength = bill.getBillItems().length;
            var restaurant = POS.get("restaurantModel");
            bill.set('restaurant', DbRecorder.convert2JSON(restaurant));
            bill.resetCheckInTime();
            bill.setOrderDate();
            if (billLength === 0) {
                var number = parseInt(POS.get('billCounts'));
                number++;
                bill.set({number: number});
                POS.set({billCounts: number});
            }
            var billDetail = DbRecorder.convert2JSON(bill);
            if (restaurant.get('fastFood')) {
                billDetail.fastfood = true;
            }
            billDetail.table = this.model.toJSON();
            billDetail.uitems = unConfirmItems;
            billDetail.uAmount = unConfirmTotal;

            // if (printSetting.get("orderReceipt")) {
            //     PrintService.printOrderReceipt(billDetail);
            // }
            // if (printSetting.get("dispatchSlip")) {
            //     PrintService.printDispatchReceipt(billDetail, 'dispatch');
            // }
            // if (printSetting.get("itemSlip")) {
            //     PrintService.printItemsReceipts(billDetail, null);
            // }
            // if (printSetting.get("tagSlip")) {
            //     PrintService.printTagReceipts(billDetail, null, true);
            // }
        },
        _deleteStaff: function (evt) {
            var self = this, billId = $(evt.currentTarget).closest('.show-courier').data('id'),
                bill = self.model.getActiveBillCollection().findWhere({'id': billId});
            var result = $.post("/bill/setCourier", {billId: billId});
            result.done(function (response) {
                if (response.success) {
                    $(evt.currentTarget).closest('.show-courier').hide().siblings('.courier').show();
                    bill.set({'courier': null}, {silent: true});
                }
            });
            result.fail(function (response) {

            });
            return false;
        },
        _selectStaff: function (staff) {
            var self = this,
                bill = self.model.getActiveBillCollection().findWhere({'id': staff.evt.data('id')});
            var result = $.post("/bill/setCourier", {billId: bill.id, staffId: staff.id});
            result.done(function (response) {
                if (response.success) {
                    staff.evt.hide().siblings(".show-courier").show().find('.name').text(i18n.msg('pos.bill.status.Delivering.staff') + ":" + staff.name);
                    bill.set({'courier': staff}, {silent: true});
                    self.chooseMemberModalView.hide();
                }
            });
            result.fail(function (response) {

            });
            return false;
        },
        _setCourier: function (evt) {
            this.chooseMemberModalView = new ChooseMemberModalView({evt: $(evt.currentTarget), type: "COURIER"});
            this.chooseMemberModalView.show();
            this.listenToOnce(this.chooseMemberModalView, 'chooseStaff', this._selectStaff);
        },
        deliver_click: function (evt) {
            var self = this,
                confirmModel = new Backbone.Model({}),
                table = self.model,
                btn = $(evt.currentTarget),
                message = i18n.msg('pos.bill.complete.confirmation'),
                data = btn.data(), bill;
            bill = data.id ? table.getActiveBillCollection().get(data.id) : table.getActiveBillCollection().get(data.cid);
            if (bill) {
                confirmModel.on("change:shouldConfirm", function () {
                    confirmModel.set({confirmed: true});
                    bill.pleaseComplete();
                    btn.closest(".tab-pane").find(".btn.checkout").addClass('hidden');
                    btn.closest(".tab-pane").find(".btn.confirm").addClass('hidden');
                    btn.closest(".tab-pane").find(".btn.deliver").addClass('hidden');
                    btn.remove();
                    table.trigger("change");
                    if (table.get("currentBill").id == bill.id) {
                        table.set("currentBill", null);
                    }
                });
                new ModalView({
                    model: confirmModel,
                    body: "<h3 style='text-align: center;'>" + message + "</h3>",
                    save: i18n.msg('pos.order.confirm.yes')
                }).render();
            }
        },
        cancelOrder: function (evt) {
            var self = this,
                confirmModel = new Backbone.Model({}),
                table = self.model,
                btn = $(evt.currentTarget),
                message = i18n.msg('pos.bill.cancel.label'),
                data = btn.data(), bill;
            bill = data.id ? table.getActiveBillCollection().get(data.id) : table.getActiveBillCollection().get(data.cid);
            if (bill) {
                if (bill.get("hasPaidOnline")) {
                    message = i18n.msg('pos.bill.cancel.with.online.payment');
                }
                confirmModel.on("change:shouldConfirm", function () {
                    confirmModel.set({confirmed: true});
                    bill.pleaseCancel();
                    btn.closest(".tab-pane").find(".btn.checkout").addClass('hidden');
                    btn.closest(".tab-pane").find(".btn.confirm").addClass('hidden');
                    btn.remove();
                    table.trigger("change");
                    if (table.get("currentBill").id == bill.id) {
                        table.set("currentBill", null);
                    }
                });
                new ModalView({
                    model: confirmModel,
                    body: "<h3 style='text-align: center;'>" + message + "</h3>",
                    save: i18n.msg('pos.order.confirm.yes')
                }).render();
            }

        },

        refundOrder: function (evt) {
            console.log('refund order');
            var self = this,
                confirmModel = new Backbone.Model({}),
                table = self.model,
                btn = $(evt.currentTarget),
                message = i18n.msg('pos.bill.cancel.label'),
                data = btn.data(), bill;
            bill = data.id ? table.getActiveBillCollection().get(data.id) : table.getActiveBillCollection().get(data.cid);
            var offlineMsg = i18n.msg("pos.refund.offline");
            if (!POS.getUser().isAdmin && POS.getRestaurant().get('staffCashier')) {
                new ModalView({
                    hideFooter: true,
                    body: "<h3 style='text-align: center;'>" + i18n.msg('pos.refund.adminOnly') + "</h3>"
                }).render();
                return false;
            }
            if (!DbRecorder.getStatusModel().get("online")) {
                new ModalView({
                    hideFooter: true,
                    body: "<h1 class='large' style='color: white; text-align: center;'>" + offlineMsg + "</h1>"
                }).render();
                return false;
            }
            if (!bill) {
                return false;
            }
            if (bill.get("hasPaidOnline")) {
                message = i18n.msg('pos.bill.cancel.with.online.payment');
            }
            confirmModel.on("change:shouldConfirm", function (m) {
                confirmModel.set({confirmed: true});
                console.log('bill', bill);
                var result = $.post('/bill/cancelOnlinePayment', {id: bill.id});
                result.done(function (res) {
                    if (res.success) {
                        bill.refundAll(m.get("reason"));
                        btn.remove();
                        table.trigger("change");

                        if (table.get("currentBill").id == bill.id) {
                            table.set("currentBill", null);
                        }

                    } else {
                        alert(res.error ? res.error : "无法完成退款");
                    }
                });

                result.fail(function () {
                    alert('无法完成退款');
                });

            });
            new BillRefundModalView({model: confirmModel}).render();
            return false;
        },

        _switchBillItems: function (evt) {
            var self = this, cid = $(evt.currentTarget).data('cid'),
                id = $(evt.currentTarget).data('id');
            var bill = self.model.getActiveBillCollection().get(cid);
            if (!this.billItemsSelectModalView) {
                this.billItemsSelectModalView = new BillItemsSelectModalView(bill.getBillUnPackItems());
            }
            this.billItemsSelectModalView.model = bill.getBillUnPackItems();
            this.billItemsSelectModalView.table = this.model;
            this.billItemsSelectModalView.bill = bill;
            this.billItemsSelectModalView.render();
            this.listenToOnce(this.billItemsSelectModalView, "closed", function () {
                self.$el.modal('hide');
            });
        },
        _creditBill: function (evt) {
            var self = this, cid = $(evt.currentTarget).data('cid'),
                id = $(evt.currentTarget).data('id'),
                status = $(evt.currentTarget).hasClass('on-credit');
            var bill = self.model.getActiveBillCollection().get(cid);
            var jxhr = $.post("/bill/updateOnCreditBill", {billId: id, status: status});
            jxhr.done(function (response) {
                if (response.success) {
                    bill.set({onCreditBill: status});
                    self.render();
                }
            });
            jxhr.fail(function (response) {
                console.log("Failed to credit bill status " + id);
            });
        },

        _refundBill: function (evt) {
            var self = this;
            var btn = $(evt.currentTarget).closest(".billsTabContainer");
            if (!POS.getUser().isAdmin && POS.getRestaurant().get('staffCashier')) {
                var admins = POS.getRestaurantAdmins();
                var passwordEntryEl = $(PasswordEntry({admins: admins}));
                var model = new Backbone.Model();
                var passwordEntry = new PasswordEntryView({el: passwordEntryEl, model: model});
                var passwordModalView = new ModalView({
                    body: passwordEntryEl,
                    hideFooter: true
                }).render();
                passwordModalView.$el.find('.modal-content').addClass('passwordModal');
                passwordModalView.listenToOnce(model, "confirm", function () {
                    if (btn.length > 0) {
                        self.refundOrder(evt);
                    } else {
                        self.refundBill(evt);
                    }
                    passwordModalView.close();
                });
                passwordModalView.listenToOnce(model, "cancel", passwordModalView.close, passwordModalView);
            } else {
                if (btn.length > 0) {
                    this.refundOrder(evt);
                } else {
                    this.refundBill(evt);
                }
            }
            return false;
        },

        refundBill: function (evt) {
            console.log("refunding item");
            var printSetting = POS.getPrinterSetting();
            var offlineMsg = i18n.msg("pos.refund.offline");
            if (!DbRecorder.getStatusModel().get("online")) {
                new ModalView({
                    hideFooter: true,
                    body: "<h1 class='large' style='color: white; text-align: center;'>" + offlineMsg + "</h1>"
                }).render();
                return false;
            }

            var self = this, bill, confirmModel = new Backbone.Model({}),
                btn = $(evt.currentTarget),
                billItem = btn.closest(".bill"),
                amount = billItem.find(".amount"),
                refundAmount = billItem.find(".refundAmount"),
                currency = POS.getRestaurant().get("currencySymbol"),
                message = i18n.msg('pos.bill.cancel.label');
            if (billItem.data('id')) {
                bill = self.model.getActiveBillCollection().find({id: billItem.data('id')});
            } else {
                bill = self.model.getActiveBillCollection().find(function (item) {
                    return item.cid == billItem.data('cid');
                });
            }

            confirmModel.on("change:shouldConfirm", function (m) {
                confirmModel.set({confirmed: true});
                bill.refundAll(m.get("reason"));
                amount.text(currency + bill.toJSON().originalShouldPayAmount.toFixed(2));
                refundAmount.text(currency + bill.get("refundAmount").toFixed(2));
                billItem.addClass("hasRefund");
                btn.remove();
                self.billList();
                if (printSetting.get("returnSlip")) {
                    var billDetail = DbRecorder.convert2JSON(bill);
                    billDetail.table = self.model.toJSON();
                    bill.getBillItems().forEach(function (model) {
                        PrintService.printItemReceipts(billDetail, DbRecorder.convert2JSON(model), "Refund");
                    });
                }
            });
            new BillRefundModalView({model: confirmModel}).render();
            return false;
        },
        printBill: function (evt) {
            var self = this, btn = $(evt.currentTarget),
                billItem = btn.data('cid') ? btn : btn.closest(".bill"),
                bill = self.model.getActiveBillCollection().get(billItem.data('cid')),
                printActionsView = new BillPrintActionsView({
                    bill: bill,
                    table: self.model,
                    model: new Backbone.Model({}),
                    el: self.printEL
                });
            var printActionsViewModal = new ModalView({
                body: printActionsView.el,
                title: i18n.msg("pos.printer.receipt.type.selection.label"),
                save: i18n.msg("pos.label.print")
            }).render();
            printActionsViewModal.$el.find(".modal-content").addClass("printActionModal");
            printActionsViewModal.$el.find(".btn-confirm").addClass("printAction");
            printActionsViewModal.model.on("change:confirmedTime", function () {
                console.log("2abc");
                printActionsView._print();
                printActionsViewModal.close();
            });
            printActionsViewModal.model.on("change:closeTime", function () {
                printActionsViewModal.close();
            });
            return false;
        },

        beforeCheckOut: function (evt) {
            var self = this;
            var table = self.model;
            var billId = $(evt.target).data("id");
            if (!billId) {
                billId = $(evt.target).closest('a').data("id");
            }
            var bills = this.model.getBillCollection();
            var selectedBill = bills.get(billId);
            if (selectedBill) {
                self.model.setCurrentBill(selectedBill)
            }
            const TOOIE = window.TOOIE_INIT_PARAMS;
            if (TOOIE.isExpRest) {
                _mp("V开始结账");
            }
            window.location.href = $(evt.target).attr("href") || $(evt.target).closest("a").attr("href");
            return false;
        },

        showLeftPanel: function () {
            this.$('.table-right').toggleClass('minimize');
            this.$('.table-left').toggleClass('expanded');
        },

        toggleBillList: function () {
            this.$(".table-left").toggleClass("expandBillList");
        }
    });
};

export default main();


// WEBPACK FOOTER //
// ./src/view/table/TableView.js